import React, { Component } from 'react'

export class Map extends Component {
  render() {
    const mapSrc =
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7953.0693079439225!2d-74.04742825111731!3d4.676711914398323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9a91f8f7cbd1%3A0x98bdebc35b42ba29!2sCra.%2011a%20%2393a-80%2C%20Bogot%C3%A1!5e0!3m2!1sen!2sco!4v1582807035165!5m2!1sen!2sco'
    return <iframe id="mapDiv" src={mapSrc} frameBorder="0" style={{ border: 0 }} allowFullScreen />
  }
}
